import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import { useEffect, useRef, useState } from "react";
import { Clipboard, CreditCard } from "react-feather";
import { LIMIT_NAME_ADS, LIMIT_TEXT_ADS, PRICE_PER_VIEWS_ADS } from "../../utils/vars";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useMessage } from "../../global-components/src";
import { useAuth } from "../../global-components/src";
import Spinner from "../../global-components/src/components/spinner/spiner";
import PreviewAds from "./preview-ads";
import { Ads, AdsPreview, ImagePost } from "../../types";
import { errorMessage } from "../../utils/TextManagerTwo";
import { formatCurrency, formatCurrencyToFloat } from "../../utils/numbers";
import { PACOCA_API_URL, PACOCA_URL } from "../../global-components/src/utils/vars";
import { logEvent } from "../../components/analytics-tracker";
import { PaymentTypes } from "../../global-components/src/types";
import { verifyLinks } from "../../global-components/src/utils/text";
import { RewriteWithAIButton } from "../../components/rewrite-with-ai-button";
import { RefreshCw, Smile, WalletIcon, QrCodeIcon } from "lucide-react";
import EmojiPickerNative from "../../components/Textarea/Emojis/emoji-picker-native";
import { getNativeKeyboardHeight, getNativeNavigationHeight } from "../../utils/platform";
import { useTranslation } from "react-i18next";
import "./style.css";

const RegisterAds = () => {
    const { t } = useTranslation();
    const [errorsInput, setErrorsInput] = useState<{
        name?: string[]; text?: string[]; expectedViews?: string[];
        price?: string[]; img?: string[]; terms?: string[];
        buttonText?: string[]; buttonUrl?: string[];
    }>({});
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [text, setText] = useState("");
    const [price, setPrice] = useState<string | null>(null);
    const [images, setImages] = useState<ImagePost[]>([]);
    const [buttonText, setButtonText] = useState(() => t("ads.register.buttonTextPlaceholder"));
    const [buttonUrl, setButtonUrl] = useState("");
    const [value, setValue] = useState<number | null>();
    const [spaceBottom] = useState(30);
    const [paymentMethod, setPaymentMethod] = useState<PaymentTypes>("wallet");
    const [walletBalance, setWalletBalance] = useState<number>(0);
    const [loadingWallet, setLoadingWallet] = useState<boolean>(true);
    const [terms, setTerms] = useState(false);
    const [bottomPadding, setBottomPadding] = useState(5);
    const [showEmoji, setShowEmoji] = useState(false);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [error, setError] = useState("");

    const [ads, setAds] = useState<Ads | null>(() => {
        const saved = sessionStorage.getItem("ads");
        return saved ? JSON.parse(saved) : null;
    });
    const [expectedViews, setExpectedViews] = useState<number | null>(100);
    const [loadingVerifyPayment, setLoadingVerifyPayment] = useState(false);
    const [copiado, setCopiado] = useState(false);
    const navigate = useNavigate();
    const { setMessage } = useMessage();
    const { token, user } = useAuth();

    const [adsPreview, setAdsPreview] = useState<AdsPreview>({
        buttonText, buttonUrl, text: "", content: "", user: user ?? null, price: null
    });
    const [formatedAmount, setFormatedAmount] = useState<number>(0);
    const [oldValue, setOldValue] = useState<string>(
        sessionStorage.getItem(`oldValueAds${ads?.id}`) || ""
    );
    const [qrCode, setQrCode] = useState<string | null>(() =>
        sessionStorage.getItem(`qrCodeAds${ads?.id}`) ?? null
    );
    const [copyPaste, setCopyPaste] = useState<string | null>(() =>
        sessionStorage.getItem(`copyPasteAds${ads?.id}`) ?? null
    );
    const [transaction, setTransaction] = useState<any>(() => {
        const saved = sessionStorage.getItem(`transactionAds${ads?.id}`);
        return saved ? JSON.parse(saved) : null;
    });

    useEffect(() => {
        if (qrCode)       sessionStorage.setItem(`qrCodeAds${ads?.id}`, qrCode);
        if (copyPaste)    sessionStorage.setItem(`copyPasteAds${ads?.id}`, copyPaste);
        if (transaction)  sessionStorage.setItem(`transactionAds${ads?.id}`, JSON.stringify(transaction));
        if (formatedAmount && !qrCode) sessionStorage.setItem(`oldValueAds${ads?.id}`, String(formatedAmount));
        if (ads)          sessionStorage.setItem("ads", JSON.stringify(ads));
    }, [qrCode, copyPaste, transaction, formatedAmount, ads]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (transaction?.gateway_txid) verifyPayment();
        }, 3000);
        return () => clearInterval(interval);
    }, [transaction]);

    useEffect(() => {
        const handler = () => {
            const h = getNativeKeyboardHeight();
            const nav = getNativeNavigationHeight() ?? 0;
            setBottomPadding(h ? h + nav + 10 : nav + 10);
        };
        window.addEventListener("keyboardHeightChange", handler);
        return () => window.removeEventListener("keyboardHeightChange", handler);
    }, []);

    useEffect(() => {
        setLoadingWallet(true);
        axios.get(`${PACOCA_API_URL}/wallet`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            setWalletBalance(Number(res.data.balance));
        }).finally(() => setLoadingWallet(false));
    }, [ads, open]);

    useEffect(() => { if (value) setFormatedAmount(value); }, [value]);
    useEffect(() => { if (formatedAmount > walletBalance) setPaymentMethod("gerencianet_pix"); }, [formatedAmount]);
    useEffect(() => { setOldValue(formatCurrency(String(ads?.price))); }, [ads]);

    useEffect(() => {
        setAdsPreview(prev => ({
            ...prev,
            text: text.trim() ? text : "",
            price: price ?? "",
            buttonText: buttonText.trim() ? buttonText : "Conversar"
        }));
    }, [text, price, buttonText]);

    useEffect(() => {
        if (user?.id) setButtonUrl(PACOCA_URL + `/chat/@${user.user_name}`);
    }, [user]);

    useEffect(() => {
        setValue(expectedViews ? expectedViews * PRICE_PER_VIEWS_ADS : null);
    }, [expectedViews]);

    const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) =>
        setPrice(formatCurrency(e.target.value));

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return;
        const files = Array.from(e.target.files);
        if (images.length + files.length > 5) { alert(t("ads.register.maxImages")); return; }
        const newImages: ImagePost[] = files.map((file, idx) => ({
            id: Date.now() + idx, path: URL.createObjectURL(file), file, type: 0, id_post: 0
        }));
        setImages(prev => [...prev, ...newImages]);
    };

    const removeImage = (index: number) => {
        setImages(prev => {
            const updated = [...prev];
            URL.revokeObjectURL(updated[index].path);
            updated.splice(index, 1);
            return updated;
        });
    };

    const copyQrCode = async () => {
        if (!copyPaste) return;
        await navigator.clipboard.writeText(copyPaste);
        setCopiado(true);
        setTimeout(() => setCopiado(false), 2000);
    };

    const verifyPayment = async (manual = false) => {
        if (manual) setLoadingVerifyPayment(true);
        try {
            const response = await axios.post(`${PACOCA_API_URL}/ads/verify-payment`,
                { gateway_txid: transaction.gateway_txid },
                { headers: { Accept: "application/json", Authorization: `Bearer ${token}` } }
            );
            if (response.data.status === "completed") {
                setMessage(t("ads.register.paymentConfirmed"), "success");
                cancel();
                if (ads?.id) navigate(`/anuncios/meus-anuncios/${ads.id}`);
            }
            if (manual) setMessage(t("ads.register.paymentNotConfirmed"), "error");
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        } finally {
            setLoadingVerifyPayment(false);
        }
    };

    const cancel = () => {
        setOldValue(""); setValue(0); setQrCode(null); setCopyPaste(null); setTransaction(null);
        sessionStorage.removeItem(`qrCodeAds${ads?.id}`);
        sessionStorage.removeItem(`copyPasteAds${ads?.id}`);
        sessionStorage.removeItem(`transactionAds${ads?.id}`);
        sessionStorage.removeItem(`oldValueAds${ads?.id}`);
        sessionStorage.removeItem("ads");
    };

    const handleSubmit = async () => {
        setError("");
        setErrorsInput({});
        setLoading(true);
        try {
            const errors: Record<string, string[]> = {};
            if (!name) errors.name = [t("ads.register.errorNameRequired")];
            else if (name.length > LIMIT_NAME_ADS) errors.name = [t("ads.register.errorNameLimit", { limit: LIMIT_NAME_ADS })];
            if (text.length > LIMIT_TEXT_ADS) errors.text = [t("ads.register.errorTextLimit", { limit: LIMIT_TEXT_ADS })];
            if (!terms) errors.terms = [t("ads.register.errorTerms")];
            if (!expectedViews) errors.expectedViews = [t("ads.register.errorViews")];
            if (!buttonText) errors.buttonText = [t("ads.register.errorButtonText")];
            if (!buttonUrl) errors.buttonUrl = [t("ads.register.errorButtonUrl")];
            if (Object.keys(errors).length > 0) throw { response: { data: { errors } } };
            if (!text && !images.length) throw { response: { data: { message: t("ads.register.errorImageOrText") } } };
            if ((text && verifyLinks(text)) || (buttonUrl && verifyLinks(buttonUrl))) {
                setMessage(t("ads.register.suspiciousLink"), "error");
                setLoading(false);
                return;
            }

            const formData = new FormData();
            formData.append("name", name);
            formData.append("text", text);
            formData.append("price", String(formatCurrencyToFloat(price || "")));
            formData.append("button_text", buttonText);
            formData.append("button_url", buttonUrl);
            formData.append("expected_views", String(expectedViews));
            formData.append("gateway", paymentMethod);

            if (images.length) {
                const uploadPayload = images.map(() => ({ type: "image" }));
                const { data: uploadUrls } = await axios.post(
                    PACOCA_API_URL + "/generate-upload-urls", { files: uploadPayload },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                await Promise.all(uploadUrls.map((item: { url: string }, i: number) =>
                    axios.put(item.url, images[i].file)
                ));
                uploadUrls.forEach((item: { type: string; path: string }) => {
                    if (item.type === "image") formData.append("images_paths[]", item.path);
                    if (item.type === "video") formData.append("video_path", item.path);
                });
            }

            logEvent("novo_anuncio", { categoria: "Anuncio", acao: "Novo Anuncio" });

            const response = await axios.post(`${PACOCA_API_URL}/ads`, formData, {
                headers: { Accept: "application/json", Authorization: `Bearer ${token}` }
            });

            if (paymentMethod === "wallet") {
                setMessage(response.data.message, "success");
                cancel();
                navigate(`/anuncios/meus-anuncios/${response.data.ads?.id}`);
                return;
            }

            setAds(response.data.ads);
            setTransaction(response.data.transaction);
            if (response.data.gateway_data?.qrcode) {
                setQrCode(response.data.gateway_data.qrcode);
                setCopyPaste(response.data.gateway_data.copyPaste);
            }
        } catch (err: any) {
            if (err?.response?.data?.errors) {
                setErrorsInput(err.response.data.errors);
                setMessage(t("ads.register.reviewFields"), "error");
            } else {
                const msg = errorMessage(err);
                setError(msg);
                setMessage(msg, "error");
            }
        } finally {
            setLoading(false);
        }
    };

    // ── VIEW: QR CODE ──────────────────────────────────────────
    if (qrCode) {
        return (
            <>
                <Screen paddingTopTitle title={t("ads.register.title")}>
                    <div className="ads-form">
                        <div className="ads-qr-view">
                            <div className="ads-qr-hint">{t("ads.register.pixHint")}</div>
                            <div className="ads-qr-amount">R$ {oldValue}</div>
                            <img src={qrCode} alt="QR Code PIX" className="ads-qr-img" />
                            <div className="ads-actions">
                                <button type="button" className="ads-btn ads-btn-outline" onClick={copyQrCode}>
                                    <Clipboard size={15} />
                                    {copiado ? t("ads.register.copiedCode") : t("ads.register.copyPixCode")}
                                </button>
                                <button type="button" className="ads-btn ads-btn-primary" onClick={() => verifyPayment(true)} disabled={loadingVerifyPayment}>
                                    {loadingVerifyPayment ? <Spinner /> : <><RefreshCw size={15} /> {t("ads.register.verifyPayment")}</>}
                                </button>
                            </div>
                            <button type="button" className="ads-cancel-link" onClick={cancel}>{t("ads.register.cancelBtn")}</button>
                        </div>
                    </div>
                </Screen>
            </>
        );
    }

    // ── VIEW: FORM ─────────────────────────────────────────────
    return (
        <>
            <Screen paddingTopTitle title={t("ads.register.title")}>
                <Helmet>
                    <title>Paçoca - {t("ads.register.title")}</title>
                    <meta name="description" content="Crie anúncios e propagandas no Paçoca!" />
                    <meta name="keywords" content="Paçoca, rede social brasileira, Anúncios, propaganda, marketing" />
                    <meta name="author" content="Paçoca Inc." />
                    <meta property="og:title" content="Paçoca - Anuncie seu negócio no Paçoca" />
                    <meta property="og:description" content="Crie anúncios e propagandas no Paçoca!" />
                    <meta property="og:image" content="/img/link-preview.png?v=1" />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Paçoca - Anuncie seu negócio no Paçoca" />
                    <meta name="twitter:description" content="Crie anúncios e propagandas no Paçoca!" />
                    <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <div className="ads-form">

                    <div className="ads-section-label" style={{ marginTop: 4 }}>{t("ads.register.nameLabel")}</div>
                    <input
                        value={name}
                        onChange={e => setName(e.target.value)}
                        className={`ads-input${errorsInput.name || name.length > LIMIT_NAME_ADS ? " ads-input-error" : ""}`}
                        type="text"
                        placeholder={t("ads.register.namePlaceholder")}
                    />
                    <div className={`ads-counter${name.length > LIMIT_NAME_ADS ? " ads-counter-over" : ""}`}>
                        {name.length}/{LIMIT_NAME_ADS}
                    </div>
                    {errorsInput.name && <p className="ads-field-error">{errorsInput.name[0]}</p>}

                    <div className="ads-section-label">{t("ads.register.priceLabel")}</div>
                    <input
                        placeholder={t("ads.register.pricePlaceholder")}
                        type="text"
                        value={price || ""}
                        onChange={handlePriceChange}
                        className={`ads-input${errorsInput.price ? " ads-input-error" : ""}`}
                    />
                    {errorsInput.price && <p className="ads-field-error">{errorsInput.price[0]}</p>}

                    <div className="ads-row mt-3">
                        <div className="ads-col">
                            <div className="ads-section-label">{t("ads.register.buttonTextLabel")}</div>
                            <input
                                type="text"
                                value={buttonText}
                                onChange={e => setButtonText(e.target.value)}
                                className={`ads-input${errorsInput.buttonText ? " ads-input-error" : ""}`}
                                placeholder={t("ads.register.buttonTextPlaceholder")}
                            />
                            {errorsInput.buttonText && <p className="ads-field-error">{errorsInput.buttonText[0]}</p>}
                        </div>
                        <div className="ads-col">
                            <div className="ads-section-label">{t("ads.register.buttonLinkLabel")}</div>
                            <input
                                type="text"
                                value={buttonUrl}
                                onChange={e => setButtonUrl(e.target.value)}
                                className={`ads-input${errorsInput.buttonUrl ? " ads-input-error" : ""}`}
                                placeholder="https://"
                            />
                            {errorsInput.buttonUrl && <p className="ads-field-error">{errorsInput.buttonUrl[0]}</p>}
                        </div>
                    </div>

                    <div className="ads-section-label  mt-3">{t("ads.register.expectedViewsLabel")}</div>
                    <input
                        type="range"
                        min="100" max="10000" step="100"
                        value={expectedViews || 100}
                        onChange={e => setExpectedViews(Number(e.target.value))}
                        className="ads-range"
                    />
                    <div className="ads-range-meta">
                        <span>100</span>
                        <span>{expectedViews?.toLocaleString("pt-BR")} views</span>
                        <span>10.000</span>
                    </div>
                    {errorsInput.expectedViews && <p className="ads-field-error">{errorsInput.expectedViews[0]}</p>}

                    {value ? (
                        <div className="ads-price-row mt-3">
                            <span className="ads-price-label">{t("ads.register.totalValueLabel")}</span>
                            <span className="ads-price-value">R$ {value}</span>
                        </div>
                    ) : null}

                    <div className="ads-section-label mt-3">{t("ads.register.textLabel")}</div>
                    <textarea
                        ref={textareaRef}
                        value={text}
                        onChange={e => setText(e.target.value)}
                        className={`ads-textarea${errorsInput.text || text.length > LIMIT_TEXT_ADS ? " ads-input-error" : ""}`}
                    />
                    <div className="ads-textarea-toolbar">
                        <div className="cursor-pointer" onClick={() => setShowEmoji(true)}>
                            <Smile className="icon-add-emoji" />
                        </div>
                        <RewriteWithAIButton
                            type="ads"
                            setError={msg => { if (!msg.length) return; setErrorsInput(p => ({ ...p, text: [msg] })); }}
                            getText={() => text}
                            onSuccess={setText}
                        />
                        <div className={`ads-counter${text.length > LIMIT_TEXT_ADS ? " ads-counter-over" : ""}`}
                            style={{ marginTop: 0, flex: 1, textAlign: "right" }}>
                            {text.length}/{LIMIT_TEXT_ADS}
                        </div>
                    </div>
                    {errorsInput.text && <p className="ads-field-error">{errorsInput.text[0]}</p>}

                    <div className="ads-section-label mt-3">{t("ads.register.imagesLabel")}</div>
                    <input type="file" className="d-none" id="img_group" accept="image/*" multiple onChange={handleImageChange} />
                    <label className="ads-img-upload" htmlFor="img_group">
                        <img src="/img/add-image.png" className="ads-img-upload-icon" loading="lazy" />
                        <span>{t("ads.register.chooseImages")}</span>
                    </label>
                    {errorsInput.img && <p className="ads-field-error">{errorsInput.img[0]}</p>}
                    {images.length > 0 && (
                        <div className="ads-img-grid">
                            {images.map((image, index) => (
                                <div key={index} className="ads-img-thumb">
                                    <img src={image.path} alt={`preview-${index}`} />
                                    <button type="button" className="ads-img-remove" onClick={() => removeImage(index)}>&times;</button>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="ads-section-label mt-3">{t("ads.register.paymentMethod")}</div>
                    <div className="ads-pay-list">
                        <label className={`ads-pay-item${paymentMethod === "wallet" ? " sel" : ""}${formatedAmount > walletBalance ? " ads-pay-disabled" : ""}`}>
                            <input type="radio" name="payMethod" className="sr-only"
                                checked={paymentMethod === "wallet"}
                                disabled={formatedAmount > walletBalance}
                                onChange={() => setPaymentMethod("wallet")}
                            />
                            <span className={`ads-radio${paymentMethod === "wallet" ? " ads-radio-sel" : ""}`} />
                            <span className="ads-pay-icon"><WalletIcon size={16} /></span>
                            <div style={{ flex: 1 }}>
                                <div className="ads-pay-title">{t("ads.register.walletBalance")}</div>
                                <div className="ads-pay-sub">
                                    {loadingWallet ? t("ads.register.walletLoading") : `${t("ads.register.walletAvailableTag")}: R$ ${walletBalance.toFixed(2).replace(".", ",")}`}
                                </div>
                            </div>
                            {!loadingWallet && (
                                <span className={`ads-pay-tag ${formatedAmount > walletBalance ? "ads-pay-tag-warn" : "ads-pay-tag-ok"}`}>
                                    {formatedAmount > walletBalance ? t("ads.register.walletInsufficient") : t("ads.register.walletAvailableTag")}
                                </span>
                            )}
                        </label>

                        <label className={`ads-pay-item${paymentMethod === "gerencianet_pix" ? " sel" : ""}`}>
                            <input type="radio" name="payMethod" className="sr-only"
                                checked={paymentMethod === "gerencianet_pix"}
                                onChange={() => setPaymentMethod("gerencianet_pix")}
                            />
                            <span className={`ads-radio${paymentMethod === "gerencianet_pix" ? " ads-radio-sel" : ""}`} />
                            <span className="ads-pay-icon"><QrCodeIcon size={16} /></span>
                            <div>
                                <div className="ads-pay-title">Pix</div>
                                <div className="ads-pay-sub">{t("ads.register.pixQrDesc")}</div>
                            </div>
                        </label>
                    </div>

                    <div className="ads-notice mt-3">
                        <span className="ads-notice-icon">⚠️</span>
                        <span>
                            <strong>{t("ads.register.noticeTitle")}:</strong> {t("ads.register.noticeBody")}{" "}
                            <Link to="/diretrizes">{t("settings.guidelines")}</Link>.
                        </span>
                    </div>

                    <label className="ads-terms mt-3">
                        <input
                            checked={terms}
                            onChange={() => setTerms(!terms)}
                            type="checkbox"
                            className={errorsInput.terms ? "ads-input-error" : ""}
                        />
                        <span>{t("ads.register.termsText")}</span>
                    </label>
                    {errorsInput.terms && <p className="ads-field-error">{errorsInput.terms[0]}</p>}

                    <div className="ads-section-label mt-3">{t("ads.register.previewLabel")}</div>
                    <div className="ads-preview-wrap">
                        <PreviewAds numbers={expectedViews} ads={{ ...adsPreview, images }} />
                    </div>

                    {error && <div className="ads-error-box">{error}</div>}

                    <div className="ads-actions">
                        <button type="button" disabled={loading} className="ads-btn ads-btn-primary" onClick={handleSubmit}>
                            {loading ? <Spinner /> : t("ads.register.registerBtn")}
                        </button>
                    </div>

                </div>
            </Screen>

            <EmojiPickerNative
                show={showEmoji}
                setShow={setShowEmoji}
                onSelect={emoji => { setText(prev => prev + emoji); setShowEmoji(false); }}
                bottom={`${bottomPadding + (window.innerWidth <= 850 ? 10 : spaceBottom)}px`}
            />
        </>
    );
};

export default RegisterAds;
